module.exports = __webpack_public_path__ + "img/new-project1.8cfbdc2e.png";